import React from "react";
import { SectionTag } from "./ui/SectionTag";

const FEATURES = [
  { icon: "logo-1.webp", label: "4 Times Pressed" },
  { icon: "logo-2.webp", label: "Mat Ply" },
  { icon: "logo-3.webp", label: "Termite Proof" },
  { icon: "logo-4.webp", label: "Super Log Criterion" },
  { icon: "logo-5.webp", label: "72 Hours BWP Grade" },
  { icon: "logo-6.webp", label: "PFS Super Bonded" },
  { icon: "logo-8.webp", label: "Zero Gap" },
  { icon: "logo-7.webp", label: "No Harmful Emission " },
  { icon: "logo-9.webp", label: "Superior Calibration" },
];

export const WhyChooseCromaSection: React.FC = () => {
  return (
    <section
      className="relative z-10 isolate bg-white flex flex-col justify-start lg:justify-center px-2 lg:px-12 py-10 "
      aria-label="Why Choose Croma Ply"
    >
      <div className=" mx-auto pb-8 w-[90%] lg:w-[70%]">
        <div className="flex flex-col lg:flex-row gap-8 items-center lg:items-start">
          {/* Left: Header + Title — 40% width */}
          <div className="w-full lg:w-[50%]">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-6">
              <span className="" />
              <SectionTag className="!mb-[-0.2rem] md:!mb-0 font-raleway">WHY CHOOSE CROMA PLY</SectionTag>
            </div>
            <h2
              className="font-open-sans-hebrew font-bold text-2xl md:text-3xl lg:text-heading-large leading-tight bg-gradient-to-r
         from-[#e20016] from-[0%]
         via-[#712f59] via-[40%]
         to-[#005d9c] to-[100%] bg-clip-text text-transparent w-fit mx-auto lg:mx-0 text-center lg:text-left"
            >
              <span className="lg:block">9 reasons our plywood</span>
              <span className="lg:block"> defines industry </span>
              <span className="lg:block bg-gradient-to-r from-[#e20016] via-[#712f59] to-[#712f59] bg-clip-text text-transparent">
                excellence.
              </span>
            </h2>
          </div>

          {/* Right: 3x3 Grid — fills remaining width, no side gap */}
          <div className="w-full lg:flex-1 lg:w-[50%]">
            <div className="grid grid-cols-3 gap-6">
              {FEATURES.map(({ icon, label }) => (
                <div
                  key={label}
                  className="flex flex-col gap-2 items-center text-center w-fit relative"
                >
                  <div className="flex-1 flex items-center justify-center h-full w-full">
                    <img
                      src={`/assets/logos/whychooseus/${icon}`}
                      alt=""
                      className="h-full w-full object-contain"
                    />
                  </div>
                  <p className="text-xs font-bold font-raleway text-gray-900 leading-snug">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
